'use strict';

class RcmFatBrowser {
    constructor(fat) {
        this.fat = fat;
    }

    // Update browser history
    updateHistory(isProfile) {
        var urlObj = {};
        var url = '';

        // Fields
        this.fat.form.urlFields.each(function () {
            var field = $(this);
            urlObj[field.attr('name')] = $.trim(field.val());
        });

        urlObj['fullName'] = $.trim($(this.fat.resultsFilters.nameFieldSelector).val());

        // Facets non-fields
        $(this.fat.algolia.searchSettings.facetFilters).each(function (index, value) {
            var value = value.split(':');

            if (urlObj[value[0]]) {
                urlObj[value[0]] += ',' + value[1];
            } else {
                urlObj[value[0]] = value[1];
            }
        });

        // If is profile
        if (isProfile) {
            var objectID = this.fat.dataProfile.objectID;
            var uniqueId = this.fat._helperGetTeacherUniqueId(this.fat.dataProfile.objectID, this.fat.dataProfile._rankingInfo.matchedGeoLocation.lat, this.fat.dataProfile._rankingInfo.matchedGeoLocation.lng);
            urlObj['id'] = objectID;
            urlObj['uid'] = uniqueId;
        }

        // Object to query string
        Object.keys(urlObj).forEach(function (key, index) {
            if (url == '') {
                url += document.location.pathname + '?';
            } else {
                url += '&';
            }

            url += key + '=' + encodeURIComponent(urlObj[key]);
        });

        if ('undefined' != typeof history && 'undefined' != typeof history.pushState) {
            if (document.location.search == '') {
                history.replaceState(null, document.title, url);
            } else {
                history.pushState(null, document.title, url);
            }
        }

        // Console debug
        if (console && console.log) {
            console.log('RcmFatBrowser.updateHistory', url, urlObj);
        }
    }
}
